import * as React from "react";
import { Dispatch } from "redux";
import { connect } from "react-redux";

import IconButton from "@material-ui/core/IconButton";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";

import { openAddReservationDialog } from "../../actions/store/app-actions";

export interface AddReservationButtonProps {}

interface State {}

interface ConnectedAddReservationButtonProps {
	openAddReservationDialog: () => void;
}

type Props = AddReservationButtonProps & ConnectedAddReservationButtonProps;

export class AddReservationButton extends React.Component<Props, State> {
	private handleAddReservationButtonClick = () => {
		this.props.openAddReservationDialog();
	};

	public render() {
		return (
			<IconButton
				color="inherit"
				className="add-reservation-button"
				onClick={this.handleAddReservationButtonClick}
			>
				<AddCircleOutlineIcon />
			</IconButton>
		);
	}
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
	openAddReservationDialog: () => dispatch(openAddReservationDialog())
});

export const ConnectedAddReservationButton = connect(
	null,
	mapDispatchToProps
)(AddReservationButton);
